import React from "react";
import { Box, Grid2 } from "@mui/material";
import {
  ComparisonChart,
  HistoricalQuotesByInvestmentChart,
} from "@components";
import { LoadingPlaceHolder } from "@rentablo/components";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsByInvestmentChart } from "../DividendsChart/DividendsByInvestmentChart";
import { DetailInformationByInvestment } from "../DetailInformation/DetailInformation";
import { GainLossStatisticsLoader } from "../../../investment/details/GainLossStatisticsLoader";
import { useFundamentalsContext } from "../../FundamentalsContext";

export interface Props {
  investmentId: number;
  isInvestmentStock?: boolean;
  areDividendsPresent?: boolean;
}

export const SecurityFundamentalsByInvestmentId = ({
  investmentId,
  areDividendsPresent = false,
  isInvestmentStock = false,
}: Props) => {
  const { selectedMetrics, hideMetric, changeMetric, isLoading } =
    useFundamentalsContext();

  if (isLoading) {
    return (
      <Box pt={6}>
        <LoadingPlaceHolder />
      </Box>
    );
  }

  return (
    <Grid2 container spacing={4} width="100%" sx={{ mt: 5 }}>
      <FundamentalsCard>
        <GainLossStatisticsLoader investmentId={investmentId} />
      </FundamentalsCard>

      {isInvestmentStock && (
        <FundamentalsCard hideFor={["kpmg-germany"]}>
          <DetailInformationByInvestment investmentId={investmentId} />
        </FundamentalsCard>
      )}

      {areDividendsPresent && (
        <FundamentalsCard hideFor={["kpmg-germany"]}>
          <DividendsByInvestmentChart investmentId={investmentId} />
        </FundamentalsCard>
      )}

      <FundamentalsCard hideFor={["kpmg-germany"]}>
        <HistoricalQuotesByInvestmentChart investmentId={investmentId} />
      </FundamentalsCard>

      {selectedMetrics.map((value) => (
        <FundamentalsCard hideFor={["kpmg-germany"]} key={value.mainMetricKey}>
          <ComparisonChart
            key={value.mainMetricKey}
            investmentId={investmentId}
            defaultValue={value}
            mainMetricKey={value.mainMetricKey}
            onHide={() => hideMetric(value.mainMetricKey)}
            onChange={(secondValue) =>
              changeMetric(value.mainMetricKey, secondValue)
            }
          />
        </FundamentalsCard>
      ))}
    </Grid2>
  );
};
